import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import { useMemo } from 'react';
import {
  getAllContributorsCellValue,
  getAllOwnersCellValue,
  getAllViewersCellValue,
} from 'src/rbac/contributorHelper';

import { getFriendlyId } from '@/utils/friendlyId';

import type {
  OversightAssessmentFields,
  OversightAssessmentRegisterFields,
} from './types';

export const useLabelledFields = (
  records: OversightAssessmentFields[] | undefined
) => {
  const { getLabel: getStatusLabel } = useRating(
    'assessment_status',
    'oversight'
  );
  const { getLabel: getOutcomeLabel } = useRating(
    'compliance_monitoring_assessment_outcome',
    'oversight'
  );
  const labelledFields = useMemo<
    OversightAssessmentRegisterFields[] | undefined
  >(() => {
    return records?.map((d) => {
      return {
        ...d,
        SequentialIdLabel: getFriendlyId(
          'oversight_assessment',
          d.SequentialId
        ),
        Title: d.Title || '-',
        CreatedBy: d.CreatedByUser || '-',
        ModifiedBy: d.ModifiedByUser || '-',
        allOwners: getAllOwnersCellValue(d),
        allContributors: getAllContributorsCellValue(d),
        allViewers: getAllViewersCellValue(d),
        completedByUser: d.completedByUser,
        Status: d.Status!,
        StatusLabelled: getStatusLabel(d.Status),
        Outcome: d.Outcome,
        OutcomeLabelled: getOutcomeLabel(d.Outcome),
        AssessedItems: [
          ...d.assessedItems
            .filter((ai) => ai.documentAssessmentResult?.parents?.[0]?.document)
            .map(
              (ai) => ai.documentAssessmentResult?.parents[0].document?.Title
            ),
          ...d.assessedItems
            .filter((ai) => ai.riskAssessmentResult?.parents?.[0]?.risk)
            .map((ai) => ai.riskAssessmentResult?.parents[0].risk?.Title),
          ...d.assessedItems
            .filter(
              (ai) => ai.obligationAssessmentResult?.parents?.[0]?.obligation
            )
            .map(
              (ai) =>
                ai.obligationAssessmentResult?.parents[0].obligation?.Title
            ),
        ].join(', '),
      };
    });
  }, [records, getStatusLabel, getOutcomeLabel]);

  return labelledFields;
};
